import type { RoleConfig } from '../types.js';

export const consigliere: RoleConfig = {
  id: 'consigliere',
  faction: 'mafia',
  title: { ru: 'Консильери', uk: 'Консільєрі' },
  latin: 'CONSIGLIERE',
  number: '21',
  accent: '#a87a3a',
  ability: {
    ru: 'Ночью узнаёт точную роль выбранного игрока.',
    uk: 'Вночі дізнається точну роль обраного гравця.',
  },
  abilities: [
    { key: 'inspect', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
  seniority: 80,
};
